// Written by Codex on 2026-10-15
// User prompt: fix demo failures, keep everything tested and deployed
import React from 'react';

function isPageLoadError(error) {
  return error?.name === 'ChunkLoadError'
    || /loading (?:css )?chunk .+ failed|failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module/i.test(error?.message || '');
}

export default class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    const loadingFailed = isPageLoadError(this.state.error);
    return (
      <main className="min-h-screen bg-[#f8f7f5] flex items-center justify-center p-8">
        <div role="alert" className="max-w-md text-center space-y-4">
          <h1 className="text-lg font-semibold text-slate-900">
            {loadingFailed ? 'This page could not finish loading' : 'Something went wrong'}
          </h1>
          <p className="text-sm text-slate-600">
            {loadingFailed
              ? 'The connection may have been interrupted, or Certify may have been updated. Reload this page to try again.'
              : 'We could not display this page. Reload it to try again. If the problem continues, contact your administrator.'}
          </p>
          <p className="text-sm text-slate-600">Reloading may discard unsaved changes. Saved information will remain available.</p>
          <button type="button"
            onClick={() => { if (this.props.onReload) this.props.onReload(); else window.location.reload(); }}
            className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium rounded-lg transition-colors">
            Reload this page
          </button>
        </div>
      </main>
    );
  }
}
